<template>
  <div class="py-4 container-fluid">
    <div class="card mb-4">
      <div class="row">
        <div class="col-lg-6">
          <div class="card-header pb-0">
            <h6>Laporan Pajak Pembelian</h6>
            <p class="text-xs mb-0">Dari faktur vendor berstatus Posted. Gunakan untuk mencocokkan PPN Masukan (e-Faktur / Coretax) dan bukti potong PPh (e-Bupot).</p>
          </div>
        </div>
        <div class="col-lg-3">
          <label class="form-control-label mt-2 mb-0 text-xs">Masa Pajak</label>
          <input type="month" class="form-control" v-model="period" @change="get()">
        </div>
      </div>
      <div class="card-body pt-3">
        <div class="row">
          <div class="col-md-4"><p class="text-sm mb-0">DPP PPN Masukan</p><h6>{{ fmt(report.vatTotal.dpp) }}</h6></div>
          <div class="col-md-4"><p class="text-sm mb-0">PPN Masukan</p><h6>{{ fmt(report.vatTotal.ppn) }}</h6></div>
          <div class="col-md-4">
            <p class="text-sm mb-0">PPh Dipotong</p>
            <h6 class="mb-0" v-for="(s, key) in report.pphSummary" :key="key">{{ key }}: {{ fmt(s.amount) }}</h6>
            <h6 v-if="Object.keys(report.pphSummary).length == 0">-</h6>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-4">
      <div class="card-header pb-0 d-flex justify-content-between">
        <h6>PPN Masukan ({{ report.vatIn.length }} faktur pajak)</h6>
        <argon-button variant="gradient" color="success" size="sm" @click="exportCsv('vat')" :disabled="report.vatIn.length == 0"><i class="fa fa-file-excel-o"></i> Export</argon-button>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table table-striped align-items-center mb-0">
            <thead><tr>
              <th class="text-xxs text-secondary">No. Faktur Pajak</th><th class="text-xxs text-secondary">Tgl Faktur</th><th class="text-xxs text-secondary">Vendor</th><th class="text-xxs text-secondary">NPWP</th><th class="text-xxs text-secondary">No. Invoice / PO</th><th class="text-xxs text-secondary text-end">DPP</th><th class="text-xxs text-secondary text-end">PPN</th>
            </tr></thead>
            <tbody>
              <tr v-for="(row, i) in report.vatIn" :key="'v'+i">
                <td class="text-xs font-weight-bold">{{ row.faktur_pajak_no }}</td>
                <td class="text-xs">{{ moment(row.faktur_pajak_date).locale('id').format('ll') }}</td>
                <td class="text-xs">{{ row.company_name }}</td>
                <td class="text-xs">{{ row.npwp }}</td>
                <td class="text-xs">{{ row.invoice_no }} / {{ row.po_no }}</td>
                <td class="text-xs text-end">{{ fmt(row.dpp) }}</td>
                <td class="text-xs text-end">{{ fmt(row.ppn_amount) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header pb-0 d-flex justify-content-between">
        <h6>PPh 23 / 4(2) Dipotong ({{ report.pph.length }} faktur)</h6>
        <argon-button variant="gradient" color="success" size="sm" @click="exportCsv('pph')" :disabled="report.pph.length == 0"><i class="fa fa-file-excel-o"></i> Export</argon-button>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table table-striped align-items-center mb-0">
            <thead><tr>
              <th class="text-xxs text-secondary">Jenis</th><th class="text-xxs text-secondary">Objek PPh</th><th class="text-xxs text-secondary">Vendor</th><th class="text-xxs text-secondary">NPWP</th><th class="text-xxs text-secondary">Tgl / No. Invoice</th><th class="text-xxs text-secondary text-end">Dasar</th><th class="text-xxs text-secondary text-center">Tarif</th><th class="text-xxs text-secondary text-end">PPh</th>
            </tr></thead>
            <tbody>
              <tr v-for="(row, i) in report.pph" :key="'p'+i">
                <td class="text-xs font-weight-bold">PPh {{ row.pph_type }}</td>
                <td class="text-xs">{{ row.pph_name }}</td>
                <td class="text-xs">{{ row.company_name }}</td>
                <td class="text-xs">{{ row.npwp || '-' }}</td>
                <td class="text-xs">{{ moment(row.invoice_date).locale('id').format('ll') }} / {{ row.invoice_no }}</td>
                <td class="text-xs text-end">{{ fmt(row.pph_base) }}</td>
                <td class="text-xs text-center">{{ Number(row.pph_rate) }}%</td>
                <td class="text-xs text-end">{{ fmt(row.pph_amount) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import accounting from '@/services/accounting/accounting.service';

export default {
  name: "AccTaxReport",
  components: { ArgonButton },
  data() {
    return {
      moment: moment,
      period: moment().format('YYYY-MM'),
      report: { vatIn: [], vatTotal: {}, pph: [], pphSummary: {} },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    fmt(value) {
      return 'IDR '+Number(value || 0).toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    get() {
      let context = this;
      Api(context, accounting.taxReport({ period: context.period })).onSuccess(function(response) {
          context.report = response.data.data;
      }).onError(function() {
          toast.error('Data Retrieved Failed', { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 3000 });
      })
      .call()
    },
    exportCsv(type) {
      let rows = (type == 'vat')
        ? [['No Faktur Pajak', 'Tgl Faktur', 'Vendor', 'NPWP', 'No Invoice', 'PO', 'DPP', 'PPN']].concat(this.report.vatIn.map(r => [r.faktur_pajak_no, r.faktur_pajak_date, r.company_name, r.npwp, r.invoice_no, r.po_no, r.dpp, r.ppn_amount]))
        : [['Jenis', 'Kode Objek', 'Objek PPh', 'Vendor', 'NPWP', 'Tgl Invoice', 'No Invoice', 'PO', 'Dasar', 'Tarif', 'PPh']].concat(this.report.pph.map(r => ['PPh '+r.pph_type, r.pph_code, r.pph_name, r.company_name, r.npwp, r.invoice_date, r.invoice_no, r.po_no, r.pph_base, r.pph_rate, r.pph_amount]));
      let csv  = rows.map(row => row.map(cell => '"'+String(cell === null || cell === undefined ? '' : cell).replace(/"/g, '""')+'"').join(',')).join('\n');
      let link = document.createElement('a');
      link.href = URL.createObjectURL(new Blob(['﻿'+csv], { type: 'text/csv;charset=utf-8' }));
      link.download = (type == 'vat' ? 'ppn_masukan_' : 'pph_dipotong_')+this.period+'.csv';
      link.click();
      URL.revokeObjectURL(link.href);
    },
  }
};
</script>
